<template>
    <img :src="imageSource" class="artwork-preview">
</template>
<script>
import { isString } from 'lodash';
import { toBase64 } from '@/utils/image';

export default {
    props: {
        file: {
            default: null,
            type: [String, File],
        },
    },

    data: () => ({
        imageSource: null,
    }),

    watch: {
        file: {
            immediate: true,

            /**
             * Handles change of the file.
             *
             * @param  {File} file File instance.
             */
            async handler(file) {
                this.imageSource = await this.loadImageSource(file);
            },
        },
    },

    methods: {
        /**
         * Converts File object to base64 URL string or return image URL.
         *
         * @param   {string|File|null} file File to convert.
         * @returns {string}                URL to image.
         */
        async loadImageSource(file) {
            if (isString(file)) {
                return file;
            }

            if (file instanceof File) {
                return await toBase64(file);
            }

            return null;
        },
    },
};
</script>
